// The three roles gated by "Roles for Approval" flows (Finalize Recipe,
// Process Library approval sequence, Production Scheduler workflow config,
// and the recipe/batch approval-status checklists across ViewRecipe /
// ScheduledBatches / PendingRecipe / ViewPackageRecipe / PendingPackView).
//
// Matched primarily on `role_type` — a stable identifier the backend is
// adding to the role table (see handoff to backend team), immune to
// renaming a role's display name via Role Management. Falls back to
// matching the display name (`role` or `role_name`, depending which
// endpoint the object came from) when `role_type` isn't present yet (rows
// created before the backend field ships), so this degrades to the old
// (fragile) behavior instead of breaking outright in the meantime.
export const APPROVAL_ROLE_NAMES = {
  PRODUCTION_MANAGER: 'Production Manager',
  RD: 'R&D',
  QA: 'QA',
};

const displayName = (role) => role?.role ?? role?.role_name;

export const matchesApprovalRole = (role, type) =>
  role?.role_type ? role.role_type === type : displayName(role) === APPROVAL_ROLE_NAMES[type];

export const isApprovalRole = (role) =>
  Object.keys(APPROVAL_ROLE_NAMES).some((type) => matchesApprovalRole(role, type));

export const approvalRoleOrder = (role) =>
  Object.keys(APPROVAL_ROLE_NAMES).findIndex((type) => matchesApprovalRole(role, type));
